import { Box, LinearProgress } from '@mui/material';
import React, { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import TopBar from './TopBar';

const isUserScreen = (pathname) => /^\/profile\/[^/]+\/timeline\/?$/.test(pathname);

const styles = {
  container: {
    minHeight: '90vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: (theme) => ({
    paddingTop: 0,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '10px'
    }
  })
};

function Dashboard() {
  const location = useLocation();
  const [openNavBar, setOpenNavBar] = useState(() => isUserScreen(location.pathname));

  useEffect(() => {
    setOpenNavBar(isUserScreen(location.pathname));
  }, [location.pathname]);

  // const { oktaAuth, authState } = useOktaAuth();

  // useEffect(() => {
  //   if (
  //     (authState.accessToken.expiresAt - Math.trunc(Date.now() / 1000)) / 60 <
  //     30
  //   ) {
  //     const newToken = oktaAuth.getAccessToken();
  //     localStorage.setItem('token', newToken);
  //     sessionStorage.setItem('token', newToken);
  //   }
  // }, [authState]);

  return (
    <>
      <TopBar onOpenNavBar={() => setOpenNavBar((prev) => !prev)} openNavBar={openNavBar} />
      <NavBar onClose={() => setOpenNavBar(false)} open={openNavBar} />
      <Box sx={styles.container}>
        <Box
          sx={[styles.content, { paddingLeft: openNavBar ? '300px' : 0 }]}
        >
          <Suspense fallback={<LinearProgress />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </>
  );
}

export default Dashboard;
